module.exports = __webpack_public_path__ + "static/media/icon_system_rituals_social_twitter.4a8e94cd.svg";